<template>
  <CRow>
    <CCol xs="12" sm="12" md="12" lg="1" xl="1" class="mt-1"></CCol>
    <CCol xs="12" sm="12" md="12" lg="6" xl="6" class="mt-1">
      <CCard accent-color="success">
        <CCardBody>
          <FullCalendar :options="calendarOptions" />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-1">
      <CCard accent-color="primary">
        <CCardHeader class="d-flex justify-content-between">
          <span><i class="fas fa-user-check"></i> {{ quote.title }}</span>
          <button
            @click="mtdBack"
            type="button"
            class="btn btn-sm text-white"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Ir a Inicio
          </button>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol xl="6" lg="12" md="6" sm="12" xs="12">
              <CInput
                label="Fecha de cita"
                v-model="quote.dateFormat"
                :disabled="true"
              />
            </CCol>
            <CCol xl="6" lg="12" md="6" sm="12" xs="12">
              <CSelect
                label="Hora de cita"
                :options="timeOptions"
                :value="quote.hour"
                @change="(e) => { quote.hour = e.target.value; mtdOnHourChange(); }"
              />
            </CCol>
            <CCol xl="12" md="12" sm="12" xs="12">
              <label>Encargado</label>
            </CCol>
            <CCol xl="12" md="12" sm="12" xs="12">
              <v-select
                v-model="quote.barber"
                :reduce="(name) => name.id"
                :options="barbers"
                placeholder="Seleccione varias opciones..."
                label="label"
                :close-on-select="false"
                multiple
              />
            </CCol>
            <CCol xl="6" lg="6" md="8" sm="8" class="mt-1 col-9" >
              <CInput
                label="Documento o celular"
                v-model="quote.client.document"
                placeholder="Documento o celular"
                v-on:keypress="isNumber($event)"
                @keypress.enter="mtdDocumentClient"
              />
            </CCol>
            <CCol xl="3" lg="3" md="2" sm="2" class="my-auto mt-1 col-3">
              <CButton
                class="mt-2 w-100"
                color="info"
                v-c-tooltip.hover="{ content: `Buscar documento` }"
                @click="mtdDocumentClient"
              >
                <i class="fas fa-search"></i>
              </CButton>
            </CCol>
            <CCol xl="3" lg="3" md="2" sm="2" class="my-auto mt-1 col-12">
              <CButton
                class="mt-2 w-100"
                color="primary"
                v-c-tooltip.hover="{ content: `Servicios anteriores` }"
                @click="mtdViewServices"
              >
                <i class="fas fa-cut"></i>
              </CButton>
            </CCol>
            <CCol xl="9" lg="9" md="9" sm="9" class="col-9">
              <CInput
                label="Nombre de cliente"
                v-model="quote.client.name"
                placeholder="Nombre de cliente"
              />
            </CCol>
            <CCol xl="3" lg="3" md="2" sm="2" class="my-auto mt-1 col-3">
              <CButton
                class="mt-2 w-100"
                color="info"
                v-c-tooltip.hover="{ content: `Datos del Cliente` }"
                @click="mtdViewCliente"
              >
                <i class="fas fa-user"></i>
              </CButton>
            </CCol>
            <CCol xl="12" lg="12" md="12" sm="12" class="my-auto mt-1 col-12">
              <CButton
                class="mt-2 w-100"
                color="info"
                v-c-tooltip.hover="{ content: `Servicios` }"
                @click="mtdAllServices"
              >
                Seleccionar Servicios
              </CButton>
            </CCol>
            <CCol xl="12" lg="12" md="12" sm="12" class="mt-1">
              <CInput label="Total" v-model="totalPrice" disabled type="text" />
            </CCol>
            <!-- <CCol xl="6" lg="6" md="6" sm="12" class="mt-1">
              <CInput
                label="Adelanto de pago"
                v-model="quote.advance_payment"
                type="text"
                placeholder="0"
                @blur="validateAdvancePayment"
              />
            </CCol> -->
            <CCol
              xl="12"
              lg="12"
              md="12"
              sm="12"
              xs="12"
              class="mt-1"
              v-if="booConWsp == false"
            >
              <CButton
                class="btn-sm w-100 text-white"
                color="warning"
                v-c-tooltip.hover="{
                  content: `Guardar Cita`,
                }"
                :disabled="cpButtonGuardar"
                @click="mtdVerifyCaja(0)"
              >
                <i class="fas fa-save"></i> Guardar sin recordatorio
              </CButton>
            </CCol>
            <CCol xl="12" lg="12" md="12" sm="12" xs="12" class="mt-1" v-else>
              <CButton
                class="btn-sm w-100"
                color="success"
                v-c-tooltip.hover="{
                  content: `Guardar Cita`,
                }"
                :disabled="cpButtonGuardar"
                @click="mtdVerifyCaja(1)"
              >
                <i class="fas fa-save"></i> Guardar con recordatorio
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
    <cModalPaymentMethodVue
      :title="modalPaymentMethod.title"
      :boo_modal="modalPaymentMethod.modal_form"
      :item="modalPaymentMethod.item"
      :advance_payment="modalPaymentMethod.advance_payment"
      :typeRecording ="modalPaymentMethod.typeRecording"
      @closeModalPaymentMethod="closeModalPaymentMethod"
      @submitPaymentData="handlePaymentData"
    />
    <cModalServicesAntVue
      :title="modalServiceAnt.title"
      :boo_modal="modalServiceAnt.modal_form"
      :services="modalServiceAnt.services"
      :service_types="modalService.service_types"
      @closeModalServiceAnt="closeModalServiceAnt"
    />

    <cModalDataClientVue
      :title="modalDataClient.title"
      :boo_modal="modalDataClient.modal_form"
      :data="modalDataClient.data"
      @closeModalDataClient="closeModalDataClient"
    />
    <cModalServicesVue
      :title="modalService.title"
      :boo_modal="modalService.modal_form"
      :services="modalService.services"
      :service_types="modalService.service_types"
      @closeModalServices="closeModalServices"
      @submitServicesData="handleServicesData"
      ref="modalServices"
    />
  </CRow>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import cModalPaymentMethodVue from "./modals/cModalPaymentMethod.vue";
import { mapActions } from "vuex";
import { bus } from "../../../main";
import moment from "moment";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import cModalServicesVue from "./modals/cModalServices.vue";
import cModalDataClientVue from "./modals/cModalDataClient.vue";
import cModalServicesAntVue from "../modals/cModalServicesAnt.vue";


export default {
  name: "c-citas-index",
  components: {
    FullCalendar,
    cModalPaymentMethodVue,
    cModalDataClientVue,
    cModalServicesVue,
    cModalServicesAntVue,
  },
  data() {
    return {
      // singleBarber: null,
      currentMonth: moment().format("MM"), // Mes inicial
      currentYear: moment().format("YYYY"), // Año inicial
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          listPlugin,
          momentTimezonePlugin,
        ],
        locale: "es",
        timeZone: "local",
        events: [],
        initialView: "dayGridMonth",
        validRange: {
          start: moment().format("YYYY-MM-DD"), // Fecha actual en formato YYYY-MM-DD
        },
        buttonText: {
          today: "Hoy",
          month: "Meses",
          week: "Semanas",
          day: "Días",
          list: "Lista",
        },
        headerToolbar: {
          left: "title",
          center: "prev today next",
          right: "dayGridMonth,listWeek",
        },
        weekends: true,
        selectable: true,
        editable: false,
        dayMaxEventRows: 3, // Máximo de filas de eventos visibles por día
        dayMaxEvents: true, // Máximo de eventos visibles por día
        eventMaxStack: 4, // Para timeGrid o timeline views
        moreLinkClick: "popover", // Mostrar un popover al hacer clic en "más"
        dayPopoverFormat: { weekday: "long", day: "numeric", month: "long" }, // Formato del popover
        moreLinkClassNames: "custom-more-link",
        dateClick: this.dateClick,
        eventClick: this.eventClick,
        eventContent: function (info) {
          const eventTitle = info.event.title;
          return {
            html: `<div style="font-weight:bold;background-color: #ebedef; width: 100%">${eventTitle}</div>`,
          };
        },
      },
      quote: {
        title: "Citas",
        id: "",
        client: {
          id: "",
          document: "",
          name: "",
        },
        date: null,
        hour: null,
        hour_end: null,
        dateFormat: null,
        barber: [],
        service: [],
        advance_payment: "",
        payment_methods: [],
        fech_advance: "",
        validationCrossing: true,
      },
      services: [],
      service_types: [],
      barbers: [],
      totalPrice: 0,
      modalPaymentMethod: {
        title: "PAGAR RESERVA",
        modal_form: false,
        item: {},
        advance_payment: 0,
        typeRecording: 0,
      },
      modalServiceAnt: {
        title: "VER SERVICIOS ANTERIORES",
        modal_form: false,
        services: [],
      },
      modalDataClient: {
        title: "VER DATOS DEL CLIENTE",
        modal_form: false,
        data: {},
      },
      modalService: {
        title: "SERVICIOS",
        modal_form: false,
        services: [],
        service_types: [],
      },
      verificBead: false,
      booConWsp: false,
    };
  },
  computed: {
    cpButtonGuardar() {
      return false;
    },
    timeOptions() {
      const options = [{ value: null, label: "Seleccione hora..." }];
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 15) {
          const hh = String(h).padStart(2, "0");
          const mm = String(m).padStart(2, "0");
          const time = `${hh}:${mm}`;
          options.push({ value: time, label: time });
        }
      }
      return options;
    },
  },
  created() {
    this.mtdGetData(this.currentMonth, this.currentYear);
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function (month = this.currentMonth, year = this.currentYear) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/cita/isea/index/" +
          this.$store.getters.get_company.id +
          "/" +
          this.$store.getters.get_campu.id +
          "/" +
          month +
          "/" +
          year,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // this.multiselectOptions = response.data.barber;          
          this.barbers = response.data.barber;
          this.services = response.data.services;
          this.service_types = response.data.service_types;
          const citaPorDia = {};
          response.data.quotes.forEach((quote) => {
            const fecha = quote.date;
            if (!citaPorDia[fecha]) {
              citaPorDia[fecha] = 0;
            }
            citaPorDia[fecha] += 1;
          });

          this.calendarOptions.events = Object.keys(citaPorDia).map((fecha) => {
            const citasCount = citaPorDia[fecha];
            const title = `${citasCount} Cita(s)`;
            return {
              title: title,
              start: `${fecha}T00:00:00`,
              end: `${fecha}T23:59:59`,
              type: 1,
              fecha: fecha, // citas
            };
          });
          this.showBead();
        })
        .catch((errors) => {});
    },
    dateClick: function (info) {
      const date2 = new Date(info.date);
      const auxiliar = this.fixDate(date2, "date-es");
      const hour = moment().format("H:mm");
      this.quote.date = date2.toISOString().split("T")[0];
      this.quote.dateFormat = auxiliar;
      this.quote.hour = hour;
      this.quote.title = "Nueva cita";
      this.mtdOnHourChange();
    },
    eventClick: function (payload) {
      payload.jsEvent.preventDefault();
      this.get({
        url:
          this.$store.getters.get__url +
          "/cita/getquote/" +
          this.$store.getters.get_company.id +
          "/" +
          payload.event.extendedProps.fecha,
        token: this.$store.getters.get__token,
        params: this.quote,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((errors) => {});
    },
    fixDate(date, type) {
      let dateFixed = "";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = date.getDate();
      let hours = "";
      switch (type) {
        case "date-es":
          if (date.getDate() < 10) day = "0" + day;
          dateFixed = `${day}/${month}/${year}`;
          break;
        case "date-en":
          if (date.getDate() < 10) day = "0" + day;
          dateFixed = `${year}-${month}-${day}`;
          break;
        case "time":
          date.getHours() < 10
            ? (hours += "0" + date.getHours())
            : (hours = date.getHours());
          dateFixed = `${hours}:${date
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;
          break;

        default:
          break;
      }
      return dateFixed;
    },
    mtdBack: function () {
      this.$emit("setView", "home");
    },
    mtdValidateStoreQuote: function (typeRecording) {
      if (this.quote.barber == null) {
        Swal.fire({
          title: "Escoja un Personal.",
          icon: "warning",
        });
      } else if (this.quote.date == null) {
        Swal.fire({
          title: "Escoja fecha.",
          icon: "warning",
        });
      } else if (this.quote.hour == null) {
        Swal.fire({
          title: "Escoja hora.",
          icon: "warning",
        });
      } else if (
        this.quote.client.document.length == 0 &&
        this.quote.client.name.length == 0
      ) {
        Swal.fire({
          title: "Escoja documento y nombre del cliente.",
          icon: "warning",
        });
      } else if (this.quote.service.length == 0) {
        Swal.fire({
          title: "Escoja servicios.",
          icon: "warning",
        });
      } else if (this.quote.advance_payment > 0) {
        const isValid = this.validateAdvancePayment();
        if (isValid) {
          this.mtdPaymentMethod(this.quote, typeRecording);
        }
      } else {
        this.mtdStoreCommitQuote(typeRecording);
      }
    },
    mtdStoreCommitQuote: function (typeRecording) {
      this.quote.whatsapp_sent = typeRecording;
      this.post({
        url:
          this.$store.getters.get__url +
          "/cita/isea/store/" +
          this.$store.getters.get_company.id +
          "/" +
          this.$store.getters.get_campu.id +
          "/" +
          this.$store.getters.get__user_id,
        token: this.$store.getters.get__token,
        params: this.quote,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data.state == 0 || response.data.state == 1) {
              Swal.fire({
                title: "Cita Registrada correctamente",
                icon: "success",
              });
              this.mtdGetData(this.currentMonth, this.currentYear);
              this.formatData();
              this.$refs.modalServices.clearServices();
              if (response.data.state == 1) {
                this.openTicket(response.data.voucher, response.data.quote);
              }
            }
          }
        })
        .catch((errors) => {});
    },
    openTicket(id, quote) {
      window.open(
        this.$store.getters.get__url +
          "/cita/ticket/" +
          id +
          "/" +
          quote +
          "/" +
          this.$store.getters.get__user_id,
        "_blank"
      );
    },
    /** helpers */
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode != 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdDocumentClient: function () {
      if (this.quote.client.document.length == 9) {
        this.mtdSearchClientByCE();
        return;
      }

      if (
        this.quote.client.document.length == 8 ||
        this.quote.client.document.length == 11
      ) {
        this.get({
          url: `${this.$store.getters.get__url}/cita/cliente/${this.$store.getters.get_company.id}/${this.quote.client.document}`,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.state == 0) {
            if (
              this.quote.client.document.length == 8 ||
              this.quote.client.document.length == 11
            ) {
              this.mtdSearchDocument();
            } else {
              this.quote.client.name = "";
            }
          } else if (response.statusCode == 200 && response.data.state == 1) {
            this.quote.client.name = response.data.data.name;
          }
        });
      }
    },
    mtdSearchClientByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.quote.client.document}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode != 200) {
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
          this.clearClientData();
          return;
        }

        this.quote.client.name = response.data.name;
      });
    },
    mtdSearchDocument: function () {
      if (
        this.quote.client.document.length != 8 &&
        this.quote.client.document.length != 11
      ) {
        Swal.fire({
          title: "Documento inválido",
          icon: "error",
        });
        return;
      }

      this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.quote.client.document,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo == 3) {
            this.clearClientData();
            Swal.fire({
              title: "Documento no encontrado",
              icon: "warning",
            });
          } else {
            this.populateClientData(response.data);
          }
        })
        .catch((error) => {
          console.error("Error al consultar el documento:", error);
          Swal.fire({
            title: "Error en la solicitud",
            text: "Por favor, intente nuevamente más tarde.",
            icon: "error",
          });
        });
    },
    clearClientData: function () {
      this.quote.client.name = "";
      this.quote.client.address = "";
    },
    populateClientData: function (data) {
      if (this.quote.client.document.length == 8) {
        this.quote.client.name = `${data.name} ${data.last_name}`;
      } else {
        this.quote.client.name = data.razon_social;
      }
      this.quote.client.address = data.direccion;
    },
    validateAdvancePayment() {
      if (this.quote.advance_payment < 0) {
        this.quote.advance_payment = "";
        Swal.fire({
          title: "El adelanto no puede ser negativo.",
          icon: "warning",
        });
        return false;
      }
      if (parseFloat(this.quote.advance_payment) > this.totalPrice) {
        this.quote.advance_payment = this.totalPrice;
        Swal.fire({
          title: "El adelanto no puede ser mayor al total.",
          icon: "warning",
        });
        return false;
      }
      return true;
    },
    formatData: function () {
      this.quote = {
        title: "Citas",
        id: "",
        client: {
          id: "",
          document: "",
          name: "",
        },
        date: null,
        hour: null,
        dateFormat: null,
        barber: [],
        service: [],
        advance_payment: 0,
        validationCrossing: true,
      };
      this.calendarOptions.events = []; // Si tienes eventos en el calendario que necesitas limpiar
      this.handleServicesData({
        servicios: {
          table_services: [],
          total_time: "00:00:00",
          total_price: 0,
        },
      });
    },
    mtdPaymentMethod: function (item, typeRecording) {
      this.modalPaymentMethod = {
        title: "Adelanto de Pago",
        modal_form: true,
        item: item,
        advance_payment: Number(item.advance_payment),
        typeRecording: typeRecording,
      };
    },
    closeModalPaymentMethod: function () {
      this.modalPaymentMethod = {
        modal_form: false,
      };
    },
    handlePaymentData({ filledPayments, fech_advance, typeRecording }) {
      this.quote.payment_methods = filledPayments;
      this.quote.fech_advance = fech_advance;
      this.mtdStoreCommitQuote(typeRecording);
    },
    closeModalServiceAnt: function () {
      this.modalServiceAnt.modal_form = false;
    },
    mtdViewServices: function () {
      if (this.quote.client.name.length > 0) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/cita/getservices/" +
            this.$store.getters.get_company.id +
            "/" +
            this.quote.client.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.length == 0) {
            Swal.fire({
              title: "No tiene servicios anteriores!",
              icon: "warning",
            });
          } else {
            this.modalServiceAnt.modal_form = true;
            this.modalServiceAnt.services = response.data;
          }
        });
      } else {
        Swal.fire({
          title: "Busque un cliente",
          icon: "warning",
        });
      }
    },
    closeModalDataClient: function () {
      this.modalDataClient.modal_form = false;
      this.modalDataClient.data = {};
    },
    mtdViewCliente: function () {
      if (
        this.quote.client.name.length > 0 &&
        this.quote.client.document.length > 0
      ) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/cita/cliente/" +
            this.$store.getters.get_company.id +
            "/" +
            this.quote.client.document,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.state == 0) {
            this.modalDataClient.modal_form = true;
            this.modalDataClient.data = {
              Id: "",
              name: `${this.quote.client.name || ""} ${
                this.quote.client.last_name || ""
              }`,
              address: "",
              document: this.quote.client.document || "",
              phone: "",
              email: "",
              district: "",
              fech_nacimiento: "",
              status: "",
            };
          } else {
            this.modalDataClient.modal_form = true;
            this.modalDataClient.data = response.data.data;
          }
        });
      } else {
        Swal.fire({
          title: "Busque un cliente",
          icon: "warning",
        });
      }
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
          }
        })
        .catch((errors) => {});
    },
    mtdVerifyCaja: function (typeRecording) {
      // console.log(typeRecording);
      
      if (this.verificBead == true) {
        this.mtdValidateStoreQuote(typeRecording);
      } else {
        Swal.fire({
          title: "NO HAY CAJA APERTURADA",
          text: "Aperture una caja para poder pagar",
          icon: "warning",
        });
      }
    },
    closeModalServices: function () {
      this.modalService.modal_form = false;
    },
    mtdAllServices: function () {
      if (this.services.length > 0) {
        //TO DO ENVIAR EL TYPE DE SERVICIO
        this.modalService.modal_form = true;
        this.modalService.services = this.services;
        this.modalService.service_types = this.service_types;
        console.log();
        
      } else {
        Swal.fire({
          title: "No hay servicios, por favor registre en mantenimiento",
          icon: "warning",
        });
      }
    },
    handleServicesData({ servicios }) {
      this.quote.service = servicios.table_services;
      this.totalPrice = parseFloat(servicios.total_price).toFixed(2);
    },
    mtdOnHourChange() {
      if (!this.quote.dateFormat || !this.quote.hour) {
        this.booConWsp = false;
        return;
      }

      const now = new Date();

      // DD/MM/YYYY
      const [day, month, year] = this.quote.dateFormat.split("/").map(Number);
      // HH:mm
      const [hour, minute] = this.quote.hour.split(":").map(Number);

      const selectedDateTime = new Date(year, month - 1, day, hour, minute, 0);

      // 📌 Verificar si es el mismo día
      const isSameDay =
        now.getFullYear() == year &&
        now.getMonth() == month - 1 &&
        now.getDate() == day;

      if (!isSameDay) {
        this.booConWsp = true;
        return;
      }
      const nowRounded = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        0
      );

      // 🔹 Diferencia en minutos exactos
      const diffMinutes =
        (selectedDateTime.getTime() - nowRounded.getTime()) / 1000 / 60;

      // 🔹 Regla: >= 120 minutos
      console.log(diffMinutes);
      
      this.booConWsp = diffMinutes >= 120;
    },
  },
};
</script>

<style scoped></style>